import { render, staticRenderFns } from "./AmbulanciasMain.vue?vue&type=template&id=0a6aa15e"
import script from "./AmbulanciasMain.vue?vue&type=script&lang=js"
export * from "./AmbulanciasMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports